import React from "react";

import Typography from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";

import { Div, EmptyCard, StyledCta } from "../style";

function RequestWebinarCard({ data, onShowModalClick }) {
  return (
    <EmptyCard>
      <Div flexDirection={"column"} mb="72px">
        <Typography
          variant="heading5"
          mb="24px"
          color={theme.colorsV2.primary.shade_800}
        >
          {data?.request_webinar_card?.title}
        </Typography>
        <Typography variant="label3" color={theme.colorsV2.gray.shade_600}>
          {data?.request_webinar_card?.subtitle}
        </Typography>
      </Div>
      <Div width="100%">
        <StyledCta
          bgColor={theme.colorsV2.shyft.purple_text}
          hoverColor={theme.colorsV2.shyft.purple_text}
          variant="primary1"
          fontFamily={"var(--man-700)"}
          btnPadding={"15px 32px"}
          fontSize={["14px", "15px", "16px"]}
          width="100%"
          maxWidth="231px"
          version={"v2"}
          onClick={() => onShowModalClick({ type: "NEW_WEBINAR_REQUEST" })}
        >
          {data?.request_webinar_card?.cta}
        </StyledCta>
      </Div>
    </EmptyCard>
  );
}

export default RequestWebinarCard;
